import React from 'react'
import { CardMedia as MCardMedia, CardMediaProps as MCardMediaProps } from '@material-ui/core'

export type CardMediaProps = MCardMediaProps

export default function CardMedia (props: CardMediaProps) {
  return (<MCardMedia {...props}/>)
}
